import React from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { PAGE } from "../constants/page";

import { resetBreadcrum } from "../redux/reducers/BreadcrumbSlice";
import { TestDataAdminList } from "../mock/admin/AdminHome";
import "../styles/components/Footer.scss";
import { BrowserView, MobileView } from "react-device-detect";

const navigateToLinks = (id: string) => {
  if (id === "TnC") {
    window.open(
      "https://www.elsevier.com/legal/elsevier-website-terms-and-conditions",
      "_blank"
    );
  } else if (id === "PPo") {
    window.open("https://www.elsevier.com/legal/privacy-policy", "_blank");
  } else {
    return false;
  }
};

const MobileFooter = () => {
  return (
    <>
      <div className={"logo"}>
        <img alt="logo" src="/logo.svg" />
        <img alt="logo-name" src="/logo_name.svg" />
      </div>
      <div className="footerCopyRight">Copyright © 2023 Elsevier B.V.</div>
      <ul className="list-unstyled listFooterMobile">
        <li
          className="listFooterMobileItem"
          onClick={() => {
            navigateToLinks("TnC");
          }}
        >
          Terms and Conditions
        </li>
        <li
          className="listFooterMobileItem"
          onClick={() => {
            navigateToLinks("PPo");
          }}
        >
          Privacy Policy
        </li>
      </ul>
      <div className="footerMobileContent">
        We use cookies to help provide and enhance our service and tailor
        content. By continuing you agree to the use of cookies.
      </div>
      <div className="footerMobileLogo">
        <img alt="logo" src="/relx-logo.svg" width={"90px"} />
      </div>
    </>
  );
};

const DesktopFooter = () => {
  return (
    <div className="footerDesktopContainer">
      <div className="">
        <div className={"logo"}>
          <img alt="logo" src="/logo.svg" />
          <img alt="logo-name" src="/logo_name.svg" />
        </div>
      </div>
      <div className="footerDesktopContent">
        <div className="footerDesktopContentList">
          <div>Copyright © 2023 Elsevier B.V.</div>
          <div
            className="listFooterDesktopItem"
            onClick={() => {
              navigateToLinks("TnC");
            }}
          >
            Terms and Conditions
          </div>
          <div
            className="listFooterDesktopItem"
            onClick={() => {
              navigateToLinks("PPo");
            }}
          >
            Privacy Policy
          </div>
        </div>
        <div className="footerContentText">
          We use cookies to help provide and enhance our service and tailor
          content. By continuing you agree to the use of cookies.
        </div>
      </div>
      <div className="">
        <img alt="logo" src="/relx-logo.svg" width={"90px"} />
      </div>
    </div>
  );
};

function Footer() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const navigateToDetails = (routeEndValue: string) => {
    dispatch(resetBreadcrum());

    if (routeEndValue === "globalAdmin") {
      const routeLink = PAGE.GLOBAL_STATE_ADMIN.replace(
        ":state",
        TestDataAdminList[0].stateName
      ).concat("/admin");
      navigate(routeLink);
      return;
    } else if (routeEndValue === "stateAdmin") {
      const routeLink = PAGE.STATE_ADMIN.replace(":state", "Karnataka");
      navigate(routeLink.concat("/asha"));
      return;
    } else if (routeEndValue === "search") {
      const routeLink = PAGE.GLOBAL_STATE_ADMIN.replace(":state", "Karnataka");
      navigate(routeLink);
      return;
    } else {
      const routeLink = PAGE.ADD_USERS.replace(":userId", routeEndValue);
      console.log("rout", routeLink);
      navigate(routeLink);
    }
  };

  if (location.pathname == "/screening") {
    return null;
  }

  return (
    <footer className="footer">
      <div className="container">
        <BrowserView>
          <DesktopFooter />
        </BrowserView>
        <MobileView>
          <MobileFooter />
        </MobileView>
      </div>
    </footer>
  );
}

export default Footer;
